import React from "react";
import {useParams} from "react-router-dom";
import {ToolSatis1} from "../../tool/satis/1/index";

export default function FacilityDetailViewContainer() {
    const params = useParams();
    const facilityId = Number(params.facilityId);

    return <ToolSatis1 facilityId={facilityId} />;
}
